export const useWholesaleDiscount = () => {
  const discountTiers = [
    { min: 10, discount: 0.10 }, // 10% discount for 10+ items
    { min: 25, discount: 0.15 }, // 15% discount for 25+ items
    { min: 50, discount: 0.20 }, // 20% discount for 50+ items
    { min: 100, discount: 0.25 } // 25% discount for 100+ items
  ];

  const getDiscount = (quantity: number) => {
    for (let i = discountTiers.length - 1; i >= 0; i--) {
      if (quantity >= discountTiers[i].min) {
        return discountTiers[i].discount;
      }
    }
    return 0;
  };

  const getDiscountedPrice = (basePrice: number, quantity: number) => {
    const discount = getDiscount(quantity);
    return basePrice * (1 - discount);
  };

  const getDiscountPercentage = (quantity: number) => {
    return getDiscount(quantity) * 100;
  };

  return {
    discountTiers,
    getDiscount,
    getDiscountedPrice,
    getDiscountPercentage
  };
};
